import React from "react";
import { LoginForm } from "../../../components/organism/LoginForm/LoginForm";

export const LoginPage: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div className="flex-grow container mx-auto flex flex-col items-center justify-center p-4 pt-20">
        <LoginForm />
      </div>
    </div>
  );
};
